import React, { Component } from "react"
import CoverLoader from '../coverLoader'
class Skeleton extends Component {
  //THIS IS A TEMP FILE

  render() {
    return (
      <div style={{ height: "100vh" }}>
        <CoverLoader text={"Warming Up"} className={this.props.loaderClass || ''} />
      </div>
    )
  }
}

export default Skeleton
